import PropTypes from 'prop-types';
import React from 'react';
import Button from '@99designs/react-components/components/Button';
import Icon from '@99designs/react-components/components/Icon';

const DrawerToggleButton = ({ isSelected, isDisabled, isPrimary, onAdd, onRemove, tooltip }) => {
    return (
        <Button
            variations={[
                'small',
                'icon',
                isSelected ? 'success' : isPrimary ? 'primary' : 'secondary',
            ]}
            onClick={isSelected ? onRemove : onAdd}
            isDisabled={isDisabled}
            title={isSelected ? null : tooltip}
        >
            <Icon variations={[isSelected ? 'tick-1' : 'plus-2']} />
        </Button>
    );
};

DrawerToggleButton.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isPrimary: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    tooltip: PropTypes.string.isRequired,
};

export default DrawerToggleButton;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/drawer-toggle-button.jsx